const tooltipJson = Object.freeze({
    highlight : {
        label_maker : {
            total_qr : 'Total data qr yang diberikan oleh qtrust ke label maker berikut cadangan 4%',
            total_scan : 'Total scan adalah jumlah qr label tercetak untuk diverifikasi',
            total_active : 'Total active adalah jumlah qr label tercetak yang lolos verifikasi',
            total_fail : 'Total fail adalah jumlah qr label tercetak yang gagal diverifikasi',
            total_inactive : 'Total inactive adalah jumlah qr label yang belum digunakan',
            scan_vs_active : 'Scan & Active Qr adalah jumlah scan dan qr aktif',
            detailed_by_bottle_maker : 'Kurva jumlah QR yang Success & Failed untuk masing-masing botol maker',
            qr_active_by_label_maker : 'Perbandingan total qr aktif berdasarkan label maker',
        },
        oil_maker : {
            total_qr : 'Total qr adalah jumlah botol berlabel qr yang dikirimkan oleh label maker ke botol maker',
            total_scan : 'Total scan adalah jumlah scan oleh oil maker pada konveyor mesin pengisian oli',
            total_active : 'Total active adalah jumlah botol oli (QR Code) yang aktif oleh oil maker',
            total_deactivate : 'Total deactive adalah jumlah botol oli  (QR code) yang dinonaktifkan oleh oil maker',
            qr_vs_active : 'Kurva perbandingan jumlah total QR dengan jumlah QR yang sudah aktif',
            qr_active_by_oil_maker : 'Perbandingan total botol (QR Code) aktif yang dilakukan scan oleh Oil Maker',
        },
        customer : {
            total_scan_product : 'Total botol oli yang di scan oleh customer',
            total_report_customer : 'Total pelaporan oleh customer',
            valid_product : 'Total product yang valid (Berhasil di scan oleh customer)',
            inactive_product : 'Qr inactive yang di scan oleh customer',
            expired_product : 'Total product yang sudah habis masa berlaku (3 Tahun)',
            report_reason_distribution : 'Distibusi Pelaporan berdasarkan alasan',
            scan_vs_report : `
                <b>Scan</b> adalah jumlah qrcode yang di pindai oleh pengguna
                <br>
                <br>
                <b>Valid</b> adalah jumlah qr yang terdekti valid (sudah diaktivasi oil maker) oleh pengguna
                <br>
                <br>
                <b>Report</b> adalah jumlah qrcode yang di pindai oleh pengguna yang melakukan laporan pada produk
            `
        }
    },
    customer_activities : {
        scan_activity : 'Aktivitas scan customer',
        customer_distribution : 'Peta pesebaran pelaporan dengan alasan',
        scan_history : 'Histori scan',
    },
    reports : {
        consumer_report : 'Customer Report yang didapatkan dari report yang di submit oleh customer yang melakukan pelaporan',
        checking_report : 'Report yang didapatkan dari hasil scan QR yang dibaca dari hasil printing oleh label maker',
        report_by_purchase_order : 'Report data Purchase Order(PO) dari masing-masing label maker',
        activation_report : 'Report yang didapatkan dari hasil scan QR yang dibaca dari Botol Oli yang sudah diisi oleh lubricants',
        history_report : 'Data historikal pembacaan scan QR dibedakan dari aktivasi dan deaktivasi QR',
    }
})

module.exports = { tooltipJson }